import React from 'react';
import { Home, Landmark, Heart, GraduationCap, PiggyBank, HeartHandshake, Package } from 'lucide-react';

/**
 * Компонент раздела формы для выбора типа налогового вычета
 */
const DeductionTypeSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  deductionTypes 
}) => {
  // Иконки для разных типов вычетов
  const deductionIcons = {
    property: <Home className="w-5 h-5" />,
    mortgage: <Landmark className="w-5 h-5" />,
    medical: <Heart className="w-5 h-5" />,
    education: <GraduationCap className="w-5 h-5" />,
    investment: <PiggyBank className="w-5 h-5" />,
    charity: <HeartHandshake className="w-5 h-5" />,
    comprehensive: <Package className="w-5 h-5" />
  };

  return (
    <div className="mb-6">
      <div className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
        Выберите тип налогового вычета
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {deductionTypes.map((type) => (
          <label
            key={type.id}
            className={`
              flex flex-col items-center p-4 border rounded-lg cursor-pointer transition-colors
              ${formData.deductionType === type.id
                ? 'bg-emerald-50 border-emerald-300 dark:bg-emerald-900/30 dark:border-emerald-700'
                : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700/70'
              }
            `}
          >
            <input
              type="radio"
              name="deductionType"
              value={type.id}
              checked={formData.deductionType === type.id}
              onChange={handleInputChange}
              className="sr-only"
            />
            <div className={`w-10 h-10 flex items-center justify-center rounded-full mb-2
              ${formData.deductionType === type.id
                ? 'bg-emerald-100 text-emerald-600 dark:bg-emerald-900 dark:text-emerald-300'
                : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'
              }`}
            >
              {deductionIcons[type.id]}
            </div>
            <div className="text-sm font-medium text-center text-gray-900 dark:text-white mb-1">{type.name}</div>
            {type.maxDeduction && (
              <div className="text-xs text-gray-500 dark:text-gray-400 text-center">
                До {new Intl.NumberFormat('ru-RU').format(type.maxDeduction)} ₽ возврата
              </div>
            )}
            <div className="text-xs text-gray-500 dark:text-gray-400 text-center mt-1">
              {type.description}
            </div>
          </label>
        ))}
      </div>

      {errors.deductionType && (
        <p className="mt-2 text-xs text-red-500 dark:text-red-400">
          {errors.deductionType}
        </p>
      )}

      {formData.deductionType === 'comprehensive' && (
        <div className="mt-4 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800 rounded text-yellow-800 dark:text-yellow-200 text-sm">
          <p>
            <strong>Внимание:</strong> При комплексном расчете учитываются все типы вычетов и их ограничения. 
            Заполните все необходимые разделы ниже для корректного расчета.
          </p>
        </div>
      )}

      {/* Информационный блок о типах вычетов */}
      <div className="mt-4 p-3 bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded text-gray-700 dark:text-gray-300 text-sm">
        <p>
          <strong>Справка:</strong> В России доступны разные типы налоговых вычетов с различными суммами и условиями. 
          Имущественный вычет можно получить один раз в жизни при покупке жилья (до 2 млн ₽), 
          социальные вычеты (лечение, обучение) доступны ежегодно в пределах 120 тыс. ₽.
        </p>
      </div>
    </div>
  );
};

export default DeductionTypeSection;